// theme.jsx
export const theme = {
    colors: {
      grey: {
        20: " rgba(0, 0, 0, 0.10)", //for disabled
        50: "#fafafa",
        70: "#f7f7f7",
        100: "#f4f4f6",
        200: "#eeeeee",
        300: "#e0e0e0",
        400: "#b3b3b3",        
        500: "#8c8c8c",
        600: "#757575",
        700: "#616161",
        800: "#424242",
        900: "#2b2b2b",
      },
      // Primary color palette based on #416548
      primary: {
        50: '#f7ece4ff',
        100: '#faefe6',//couleur secondaire
        200: '#edc9acff',
        300: '#f5d2b6ff',
        400: '#ddaa80',
        500: '#dfa574', // Your base color
        600: '#cc9363ff',
        700: '#b98152ff',
        800: '#a66941ff',
        900: '#8c502aff',
        950: '#6b381aff'
      },
      
      // Secondary colors based on #e2c29c
      secondary: {
        50: '#faf8f4',
        60: '#f9f6f1',
        70: '#f8f4ee',
        80: '#f7f2ec',
        90: '#f6f1ea',
        100: '#f5f0e8',
        200: '#ebe0d1',
        300: '#e2c29c', // Your base color
        400: '#d9b485',
        500: '#d0a66e',
        600: '#c79857',
        700: '#a67d47',
        800: '#856237',
        900: '#644727',
        950: '#432c17'
      },
      
      // Neutral grays
      gray: {
        50: '#f9fafa',
        100: '#f3f4f4',
        200: '#e5e7e7',
        300: '#d1d5d5',
        400: '#9ca3a3',
        500: '#6b7280',
        600: '#4b5563',
        700: '#374151',
        800: '#1f2937',
        900: '#111827',
        950: '#030712'
      },
      
      // Status colors
      success: {
        50: '#f0fdf4',
        100: '#dcfce7',
        200: '#bbf7d0',
        300: '#86efac',
        500: '#22c55e',
        600: '#16a34a',
        700: '#15803d',
        800: '#166534',
        900: '#14532d'
      },
      
      warning: {
        50: '#fffbeb',
        100: '#fef3c7',
        200: '#fde68a',
        300: '#fcd34d',
        500: '#f59e0b',
        600: '#d97706',
        700: '#b45309',
        800: '#92400e',
        900: '#78350f'
      },
      
      error: {
        50: '#fef2f2',
        100: '#fee2e2',
        200: '#fecaca',
        300: '#fca5a5',
        500: '#ef4444',
        600: '#dc2626',
        700: '#b91c1c',
        800: '#991b1b',
        900: '#7f1d1d'
      },
      
      info: {
        50: '#eff6ff',
        100: '#dbeafe',
        200: '#bfdbfe',
        300: '#93c5fd',
        500: '#3b82f6',
        600: '#2563eb',
        700: '#1d4ed8',
        800: '#1e40af',
        900: '#1e3a8a'
      },
      
      // Background colors
      background: {
        primary: '#ffffff',
        secondary: '#f8fafc',
        tertiary: '#f1f5f9',
        dark: '#0f172a'
      },
      
      // Text colors
      text: {
        primary: '#0f172a',
        secondary: '#475569',
        tertiary: '#64748b',
        inverse: '#ffffff',
        muted: '#94a3b8'
      },
      
      // Border colors
      border: {
        light: '#e2e8f0',
        medium: '#cbd5e1',
        dark: '#94a3b8'
      }
    },
    
    // Typography
    typography: {
      fontFamily: {
        sans: ['Inter', 'system-ui', 'sans-serif'],
        serif: ['Georgia', 'serif'],
        mono: ['Monaco', 'Consolas', 'monospace']
      },
      
      fontSize: {
        xs: '0.75rem',    // 12px
        sm: '0.875rem',   // 14px
        base: '1rem',     // 16px
        lg: '1.125rem',   // 18px
        xl: '1.25rem',    // 20px
        '2xl': '1.5rem',  // 24px
        '3xl': '1.875rem', // 30px
        '4xl': '2.25rem', // 36px
        '5xl': '3rem',    // 48px
        '6xl': '3.75rem'  // 60px
      },
      
      fontWeight: {
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800
      },
      
      lineHeight: {
        tight: 1.25,
        normal: 1.5,
        relaxed: 1.75
      }
    },
    
    // Spacing
    spacing: {
      xs: '0.25rem',   // 4px
      sm: '0.5rem',    // 8px
      md: '1rem',      // 16px
      lg: '1.5rem',    // 24px
      xl: '2rem',      // 32px
      '2xl': '3rem',   // 48px
      '3xl': '4rem',   // 64px
      '4xl': '6rem',   // 96px
      '5xl': '8rem'    // 128px
    },
    
    // Border radius
    borderRadius: {
      none: '0',
      sm: '0.125rem',   // 2px
      md: '0.375rem',   // 6px
      lg: '0.5rem',     // 8px
      xl: '0.75rem',    // 12px
      '2xl': '1rem',    // 16px
      '3xl': '1.5rem',  // 24px
      full: '9999px'
    },
    
    // Shadows
    boxShadow: {
      sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
      md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
      lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
      xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
      '2xl': '0 25px 50px -12px rgb(0 0 0 / 0.25)',
      inner: 'inset 0 2px 4px 0 rgb(0 0 0 / 0.05)'
    },
    
    // Breakpoints
    breakpoints: {
      xs: '0px',
      sm: '600px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
      '2xl': '1536px'
    },
    
    // Animation
    animation: {
      duration: {
        fast: '150ms',
        normal: '300ms',
        slow: '500ms'
      },
      
      easing: {
        linear: 'linear',
        ease: 'ease',
        'ease-in': 'ease-in',
        'ease-out': 'ease-out',
        'ease-in-out': 'ease-in-out'
      }
    }
  };
  
  // Utility functions
  export const getColor = (colorPath) => {
    const keys = colorPath.split('.');
    return keys.reduce((obj, key) => obj?.[key], theme.colors);
  };
  
  export const getFontSize = (size) => theme.typography.fontSize[size];
  export const getSpacing = (size) => theme.spacing[size];
  export const getBorderRadius = (size) => theme.borderRadius[size];
  export const getBoxShadow = (size) => theme.boxShadow[size];
  
  export default theme;


  // ================ Usage Examples:
//   import theme, { getColor, getFontSize } from './theme.jsx';

// // Access colors
// const primaryColor = theme.colors.primary[500]; // #416548
// const lightGreen = getColor('primary.200');
// const secondaryColor = theme.colors.secondary[300]; // #e2c29c

// // Use typography
// const headingSize = getFontSize('2xl');